export const KEYWORDS_VIEW_PATH = "/kw";

export const CREATE_KEYWORD_VIEW_PATH = "/kw/create";

export const KEYWORD_DETAIL_VIEW_PATH = "/kw/:keywordUUID";

export const EDIT_KEYWORD_VIEW_PATH: string = "/kw/:keywordUUID/edit";
